/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './action';
import './channel';
import './decision_method';
import './risk_signals';
import './preauthorize_payment_response';
import './in_transaction_top_up_flow_end_result';
import '../../orderly/app_data/internally_created_order';
import './sandbox_metadata';
import '../../pay/managed_customer_request';
import './dynamic_grant_approval_metadata';
import './risk_metadata';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "Grant": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "clientId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "action": {
                        "type": "squareup.cash.grantly.api.Action",
                        "id": 4,
                        "rule": "optional"
                      },
                      "status": {
                        "type": "squareup.cash.grantly.api.Grant.Status",
                        "id": 5,
                        "rule": "optional"
                      },
                      "type": {
                        "type": "squareup.cash.grantly.api.Grant.Type",
                        "id": 6,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "uint64",
                        "id": 7,
                        "rule": "optional"
                      },
                      "updatedAt": {
                        "type": "uint64",
                        "id": 8,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "uint64",
                        "id": 9,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "channel": {
                        "type": "squareup.cash.grantly.api.Channel",
                        "id": 11,
                        "rule": "required"
                      },
                      "appData": {
                        "type": "squareup.cash.grantly.api.Grant.AppData",
                        "id": 12,
                        "rule": "repeated"
                      },
                      "decisionMethod": {
                        "type": "squareup.cash.grantly.api.DecisionMethod",
                        "id": 13,
                        "rule": "optional"
                      },
                      "riskSignals": {
                        "type": "squareup.cash.grantly.api.RiskSignals",
                        "id": 14,
                        "rule": "optional"
                      },
                      "revokedAt": {
                        "type": "uint64",
                        "id": 15,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "ACTIVE": 1,
                          "CONSUMED": 2,
                          "REVOKED": 3,
                          "EXPIRED": 4
                        }
                      },
                      "Type": {
                        "values": {
                          "ONE_TIME": 1,
                          "EXTENDED": 2
                        }
                      },
                      "AppData": {
                        "fields": {
                          "type": {
                            "type": "squareup.cash.grantly.api.Grant.AppData.Type",
                            "id": 1,
                            "rule": "required"
                          },
                          "serializedAppData": {
                            "type": "bytes",
                            "id": 10,
                            "rule": "optional"
                          },
                          "merbroPreauthorization": {
                            "type": "squareup.cash.grantly.api.PreAuthorizePaymentResponse",
                            "id": 2
                          },
                          "merbroInTransactionTopUpFlowEndResult": {
                            "type": "squareup.cash.grantly.api.InTransactionTopUpFlowEndResult",
                            "id": 3
                          },
                          "internallyCreatedOrder": {
                            "type": "squareup.cash.orderly.app_data.InternallyCreatedOrder",
                            "id": 5
                          },
                          "sandboxMetadata": {
                            "type": "squareup.cash.grantly.api.SandboxMetadata",
                            "id": 6
                          },
                          "managedCustomerRequestFlowData": {
                            "type": "squareup.cash.pay.ManagedCustomerRequestFlowData",
                            "id": 7
                          },
                          "dynamicGrantApprovalMetadata": {
                            "type": "squareup.cash.grantly.api.DynamicGrantApprovalMetadata",
                            "id": 8
                          },
                          "riskMetadata": {
                            "type": "squareup.cash.grantly.api.RiskMetadata",
                            "id": 9
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "MERBRO_PREAUTHORIZATION": 1,
                              "MERBRO_IN_TRANSACTION_TOP_UP": 2,
                              "INTERNALLY_CREATED_ORDER": 3,
                              "SANDBOX_METADATA": 4,
                              "MANAGED_CUSTOMER_REQUEST_FLOW": 5,
                              "DYNAMIC_GRANT_APPROVAL_METADATA": 6,
                              "RISK_METADATA": 7
                            }
                          },
                          "app_data": {
                            "oneof": ["merbroPreauthorization", "merbroInTransactionTopUpFlowEndResult", "internallyCreatedOrder", "sandboxMetadata", "managedCustomerRequestFlowData", "dynamicGrantApprovalMetadata", "riskMetadata"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Grant && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Grant?.nested?.Status && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Grant?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Grant?.nested?.AppData && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Grant?.nested?.AppData?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * A grant represents an approval from a Cash customer to a third-party client
 * to perform a given action on the customer's account.
 *
 * SOURCE Grant @ squareup/cash/grantly/api/grant.proto at 22:1
 */
export const Grant = $root.lookupType('squareup.cash.grantly.api.Grant');
fixType(Grant);
Builder.createAndAttachToType(Grant);
/**
 * Next ID: 16
 * Represents the different statuses in a grant's lifecycle:
 * ACTIVE -> CONSUMED | REVOKED | EXPIRED
 *
 * SOURCE Status @ squareup/cash/grantly/api/grant.proto at 139:3
 */
Grant.Status = $root.lookupEnum('squareup.cash.grantly.api.Grant.Status').values;
/**
 * Represents the different types of grants and how many times they can be
 * used.
 *
 * SOURCE Type @ squareup/cash/grantly/api/grant.proto at 172:3
 */
Grant.Type = $root.lookupEnum('squareup.cash.grantly.api.Grant.Type').values;
/**
 * Contains data from other Cash App services that is scoped to a grant. This
 * typically includes data collected during the grant flow.
 *
 * SOURCE AppData @ squareup/cash/grantly/api/grant.proto at 191:3
 */
Grant.AppData = $root.lookupType('squareup.cash.grantly.api.Grant.AppData');
fixType(Grant.AppData);
Builder.createAndAttachToType(Grant.AppData);
/**
 * Next ID: 11
 * Describes the different types of app data that can be stored on the
 * grant. Consumers can use this to help figure out which structure has
 * been serialized into `serialized_app_data` (if present) or which
 * app data field from the `oneof` will be present (if `serialized_app_data` is
 * not present).
 *
 * SOURCE Type @ squareup/cash/grantly/api/grant.proto at 227:5
 */
Grant.AppData.Type = $root.lookupEnum('squareup.cash.grantly.api.Grant.AppData.Type').values;